
import Vue from "vue";
import SystemModule from "@/store/modules/system";
import { getModule } from "vuex-module-decorators";
import notifications from "../../lib/notifications";
import Component from "vue-class-component";
import { formatBool } from "@/utils";

const sytemModule = getModule(SystemModule);

interface DefaultField {
  key: string;
  label: string;
  formatter: any | null;
}

@Component
export default class Roles extends Vue {
  loading: boolean = true;
  roles: any[] = [];
  fields: DefaultField[] = [
    {
      key: "name",
      label: "Name",
      formatter: null
    },
    {
      key: "isAgentRole",
      label: "Is Agent Role?",
      formatter: formatBool
    },
    {
      key: "actions",
      label: "",
      formatter: null
    }
  ];

  async created() {
    try {
      this.roles = await sytemModule.getAllRoles();
    } catch (ex) {
      notifications.error("Roles", "Failed to get roles", ex);
    }

    this.loading = false;
  }
}
